import st from "@/styles/Ui.module.scss";
import clsx from "clsx";
import {useTranslation} from "react-i18next";
import {useLayoutEffect, useState} from "react";
import CommonClass from "@/utils/common.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CloseBtn from "@/ui/CloseButton.tsx";
// import useAuth from "@/hooks/auth.ts";
// import RefreshIcon from "@/svg/RefreshIcon.tsx";
// import {refresh_button_show} from "@/atoms/common.ts";
// import {useAtom} from "jotai";
// import ChevroneBtn from "@/ui/ChevroneBtn.tsx";
import ChevroneIcon from "@/svg/ChevronIocn.tsx";
import LoadIcon from "@/svg/LoadIcon.tsx";


const UpdateHandler = () => {
    const [_open, set_open] = useState(false)
    const [show_inf, set_show_inf] = useState(false)
    // const [open_refresh_btn, set_open_refresh_btn] = useAtom(refresh_button_show)
    const {t} = useTranslation()
    // const auth = useAuth()
    
    const open_handler = (x:boolean) => {
        set_open(x)
    }
    
    useLayoutEffect(() => {
        
        eventEmitter.on(CommonClass.ModalEvents.BuildVersionModalOpen, open_handler)
        
        return () => {
            eventEmitter.off(CommonClass.ModalEvents.BuildVersionModalOpen, open_handler)
        }
        
    }, []);
    
    
    if(_open) return (
        <div className={clsx(st.updated_handler)}>
            
            <div onClick={() => set_show_inf(true)} className={clsx(st.top, show_inf && st.top_open)}>
                <strong>
                    {show_inf ? t("cabinet_updated") : t("perform_update")}
                </strong>
                
                {!show_inf ? (
                    <button  className={st.close}>
                        <ChevroneIcon />
                    </button>
                ) : null}
                
            </div>
            
            <div className={clsx(st.inf, show_inf && st.open)}>
                <span>
                    {t("update_page")}
                </span>
                
                <div className={st.bot}>
                    <button
                        className={st.reload}
                        onClick={() => {
                            location.reload();
                        }}
                    >
                        <LoadIcon />
                        {t("refresh")}
                    </button>
                    
                    <CloseBtn onClick={() => set_open(false)} className={st.close_btn} />
                </div>
                
            </div>
        </div>
        
    )
    
};

export default UpdateHandler;
